
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/data-stores",
      function () {
        return require("private-next-pages/analytics/data-stores/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/data-stores"])
      });
    }
  